import React, { useEffect } from 'react'
import blog1 from '../assets/images/blog/blog-01.jpg'
import blog2 from '../assets/images/blog/blog-02.jpg'
import blog3 from '../assets/images/blog/blog-03.jpg'
import { ArrowRight, ArrowUp, BookOpen, Check, ChevronLeft, ChevronRight, Circle, Facebook, Instagram, Linkedin, Menu, Tv, Twitter, X } from 'react-feather'
import aos from 'aos'
import blogDetail from "../assets/images/blog/blog-big-01.jpg"

const Blog = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])
    return (
        <>

            {/* <!-- Start News Area --> */}
            <div className="rn-blog-area rn-section-gap section-separator" id="blog">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="500" data-aos-once="true" className="section-title text-center">
                                <span className="subtitle">Visit my blog and keep your feedback</span>
                                <h2 className="title">My Blog</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row row--25 mt--30 mt_md--10 mt_sm--10">

                        {/* <!-- Start Single blog --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="400" data-aos-once="true" className="col-lg-6 col-xl-4 mt--30 col-md-6 col-sm-12 col-12 mt--30">
                            <div className="rn-blog" data-toggle="modal" data-target="#exampleModalCenters">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <a href="#">
                                            <img src="https://miro.medium.com/max/700/1*CDKd15qCtufY765m7abmDA.jpeg" alt="Personal Portfolio Images" />
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="category-info">
                                            <div className="category-list">
                                                <a href="#">NFT</a>
                                            </div>
                                            <div className="meta">
                                                <span><i className="feather-clock"></i> 10 min read</span>
                                            </div>
                                        </div>
                                        <h4 className="title"><a>World Of Cryptoids NFT – Everything You Need To Know
                                            <i className="feather-arrow-up-right"></i></a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End Single blog --> */}

                        {/* <!-- Start Single blog --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="600" data-aos-once="true" className="col-lg-6 col-xl-4 mt--30 col-md-6 col-sm-12 col-12 mt--30">
                            <div className="rn-blog" data-toggle="modal" data-target="#blog2">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <a href="#">
                                            <img src="https://mwi.usma.edu/wp-content/uploads/2020/08/blockchain-orange-1200x640.jpg" alt="Personal Portfolio Images" />
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="category-info">
                                            <div className="category-list">
                                                <a href="#">CRYPTO</a>
                                            </div>
                                            <div className="meta">
                                                <span><i className="feather-clock"></i> 3 min read</span>
                                            </div>
                                        </div>
                                        <h4 className="title"><a href="#">CRYPTO AT WAR: How cryptocurrencies can help during times of war and crisis
                                            <i
                                                className="feather-arrow-up-right"></i></a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End Single blog --> */}

                        {/* <!-- Start Single blog --> */}
                        <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="800" data-aos-once="true" className="col-lg-6 col-xl-4 mt--30 col-md-6 col-sm-12 col-12 mt--30">
                            <div className="rn-blog" data-toggle="modal" data-target="#blog3">
                                <div className="inner">
                                    <div className="thumbnail">
                                        <a href="#">
                                            <img src="https://d3lkc3n5th01x7.cloudfront.net/wp-content/uploads/2021/12/06064959/700-X-394%402x-1.png" alt="Personal Portfolio Images" />
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="category-info">
                                            <div className="category-list">
                                                <a href="#">Metaverse</a>
                                            </div>
                                            <div className="meta">
                                                <span><i className="feather-clock"></i> 5 min read</span>
                                            </div>
                                        </div>
                                        <h4 className="title"><a href="#">Is the metaverse just a trending topic, or is it going to shape the future of social media marketing?<i className="feather-arrow-up-right"></i></a></h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- End Single blog --> */}

                    </div>
                </div>
            </div>
            {/* <!-- ENd Mews Area --> */}

            {/* <!-- Modal Blog Body area Start --> */}
            <div className="modal fade" id="exampleModalCenters" tabindex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-news" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><X /></span>
                            </button>
                        </div>

                        {/* <!-- End of .modal-header --> */}

                        <div className="modal-body">
                            <img src="https://miro.medium.com/max/700/1*CDKd15qCtufY765m7abmDA.jpeg" alt="news modal" className="img-fluid modal-feat-img" />
                            <div className="news-details">
                                <span className="date">2 May, 2021</span>
                                <h2 className="title">World Of Cryptoids NFT – Everything You Need To Know</h2>
                                <p>World of cryptoids NFT is one of the current NFTs that’s gaining much attention in the NFT space, because of the product
                                    “World Of Cryptoids Play To Earn Platform, it’s perceived as an NFT that is worth keeping eyes on.</p>
                                <p>However, you may have been wondering what the Cryptoids play to earn is and how it works, the utility of the world of cryptoids
                                    NFT in the play to earn platform, and how you can earn by playing games on the world of cryptoids platform.
                                    Search no more as I will be walking you through the step-by-step-to-earning with World of cryptoid nft gaming platform and in-depth details on how it works.</p>
                                <h4>What Is World Of Cryptoids?
                                </h4>

                                <img src="https://miro.medium.com/max/600/1*QJBYYbIzSysiO7I1mnE4hg.jpeg" alt="Personal Portfolio Images" />
                                <br /><br />
                                <p>World of Cryptoids is a multiplayer online game. A pokemon inspired metaverse world where players can breed, own,
                                    and monetize their Cryptoids using a variety of blockchain-based tokens. $CAC will be the primary governance
                                    token and the game has been designed around being a sustainable Play to Earn blockchain game (sP2E).</p>
                                <p>By fighting against other Cryptoids, players can earn token rewards and later on build their Kingdom throughout the Land play ecosystem. World of Cryptoids gameplay is designed around
                                    sustainable economy allowing players to invest in the game and receive sustainable rewards over a long period.</p>
                                <h4>World Of Cryptoids Breeding & Earning
                                </h4>
                                <p>Like real-world pets, Cryptoids can be bred to create new offspring. These offspring can be used in battle, for breeding new offspring, or can be sold on our marketplace.
                                    To manage the Cryptoid population, breeding has certain resource requirements.</p>
                                <p>Each Cryptoid can be bred a maximum of 7 times. Breeds cost CAC as well as CGC.</p>
                                <h4>Conclusion</h4>
                                <p>With the current driving entrance of metaverse and the so-called GameFi world,
                                    several blockchain games have spawned which offers players a way to “earn” through participating
                                    in games and other quests in-game.</p>

                                <p>Taking these factors into consideration, the World of Cryptoids NFT gaming platform was designed to offer players a
                                    sustainable source of income based on several built-in mechanisms.</p>
                            </div>

                            {/* <!-- Comment Section Area Start --> */}
                            <div className="comment-inner">
                                <h3 className="title mb--40 mt--50">Leave a Reply</h3>
                                <form action="#">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group"><input type="text" placeholder="Name" />
                                            </div>
                                            <div className="rnform-group"><input type="email" placeholder="Email" />
                                            </div>
                                            <div className="rnform-group"><input type="text" placeholder="Website" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group">
                                                <textarea placeholder="Comment"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <a className="rn-btn" href="#"><span>SUBMIT NOW</span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!-- Comment Section End --> */}
                        </div>
                        {/* <!-- End of .modal-body --> */}



                    </div>
                </div>
            </div>
            {/* <!-- End Modal Blog area --> */}



            {/* <!-- Modal Blog Body area Start --> */}
            <div className="modal fade" id="blog2" tabindex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-news" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><X /></span>
                            </button>
                        </div>

                        {/* <!-- End of .modal-header --> */}

                        <div className="modal-body">
                            <img src="https://cdn.zephyrnet.com/wp-content/uploads/2022/03/16053340/crypto-in-a-time-of-war.png" alt="news modal" className="img-fluid modal-feat-img" />
                            <div className="news-details">
                                <span className="date">2 April, 2022</span>
                                <h2 className="title">How cryptocurrencies can help during times of war and crisis</h2>
                                <p>One morning we wake up and find out that one country has just invaded another in the midst of a global financial and energy crisis, which shows once again how fragile relationships, economy and war are. Now, what role do cryptocurrencies play in all this? Well, it is a litmus test that cryptocurrencies
                                    have not had so far and that they are showing their nature and strength and how it could develop through the conflict.</p>
                                <p>First of all, since the beginning of the conflict (Russia - Ukraine) it meant a crisis at the level of stock exchanges and assets worldwide, falling by more than 30% in all initial indicators; bitcoin and the rest of the altcoins did not escape it, which meant its first measurement in times of war (so far the corrections experienced had been part of the market and its fluctuations),
                                    since by the nature of its development it is testing how far its correction can go.</p>
                                <p>As the days go by, it is raising its head again and the fear goes down a bit, and users and indicators are once again confident and are taking refuge in assets such as bitcoin; it is going up again. Let's hope for a stabilization for the good of the market, that's what we all hope for.

                                    Now, there is another role that so far seems to give new insight to coins and tokens in the conflict, is how the countries involved profit from it.</p>
                                <h4>Crypto, tokens and sanctions
                                </h4>

                                <p> On the other hand, the Ukrainian government, which could benefit from financial aid through tokenization (it is already doing so), has so far received more than $4,000,000 in donations through coins and tokens, which makes tokenization and coins an alternative to defray expenses during a period of conflict such as war when
                                    FIAT money cannot keep pace with the crisis, thus providing a refuge and help in an unexpected situation.</p>
                                <p>What we can visualize is that tokenization and coins will be the alternatives that both countries will be using as a means of economic aid either to avoid sanctions or to recover and help the victims (as the case may be). This shows us a different way of how tokens and coins have been used and
                                    how useful they will be in the future and in the conflicts to come. It will dawn and we will see.</p>

                            </div>

                            {/* <!-- Comment Section Area Start --> */}
                            <div className="comment-inner">
                                <h3 className="title mb--40 mt--50">Leave a Reply</h3>
                                <form action="#">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group"><input type="text" placeholder="Name" />
                                            </div>
                                            <div className="rnform-group"><input type="email" placeholder="Email" />
                                            </div>
                                            <div className="rnform-group"><input type="text" placeholder="Website" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group">
                                                <textarea placeholder="Comment"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <a className="rn-btn" href="#"><span>SUBMIT NOW</span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!-- Comment Section End --> */}
                        </div>
                        {/* <!-- End of .modal-body --> */}
                    </div>
                </div>
            </div>
            {/* <!-- End Modal Blog area --> */}


            {/* <!-- Modal Blog Body area Start --> */}
            <div className="modal fade" id="blog3" tabindex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-news" role="document">
                    <div className="modal-content">

                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><X /></span>
                            </button>
                        </div>

                        {/* <!-- End of .modal-header --> */}

                        <div className="modal-body">
                            <img src="https://media.istockphoto.com/photos/metaverse-digital-cyber-world-technology-man-with-virtual-reality-vr-picture-id1348369701?b=1&k=20&m=1348369701&s=170667a&w=0&h=W3uRsa9srlRlfeVfMBxAUpgucFhH2Iqc42kJ1HBwSVg=" alt="news modal" className="img-fluid modal-feat-img" />
                            <div className="news-details">
                                <span className="date">2 April, 2022</span>
                                <h2 className="title">What Is The Metaverse (and Why Should You Care)?</h2>
                                <p>If you have to ask what, exactly, the metaverse is — don’t feel bad.
                                </p>
                                <p>
                                    The metaverse is hardly a brand-new concept, but the speed with which it recently began making headlines is impressive. And the meaning of “metaverse” seems to expand daily, as more and more
                                    recognizable brands and businesses begin to incorporate it into their long-term plans.</p>
                                <p>While everyone from celebrities to global brands like Nike have gotten involved, Facebook is responsible for setting the metaverse buzz in motion. The company, a pioneer in social media (in a sense the earliest version of the metaverse itself) recently went through a major rebrand. Facebook is
                                     now Meta, and the company has plans to make significant moves in the metaverse world in the years to come.</p>
                                <p>This all begs the question: what even is the metaverse? The answer is at once a little bit complicated… and something you already know 
                                     even realizing it. It’s social media, the internet, video games, and online shopping all rolled into one.</p>
                                <h4>What is the metaverse?
                                </h4>

                                <p>The metaverse is a virtual world in which users, businesses, and digital platforms can exist and interact. It includes everything from virtual social and gaming platforms 
                                    (e.g. Roblox) to NFTs, a.k.a. non-fungible tokens (more on those later).</p>
                                   
                                <p>The metaverse is a longtime science-fiction dream made reality. Films like
                                     Tron and Ready Player One have long envisioned digital worlds that hold just as much weight as real ones. The metaverse is just that — a digital world accessible via virtual reality headsets, 
                                    populated by real people (often using digital avatars) and full of endless possibilities.</p>

                                    <p>It might seem like a new concept, but the idea of a multi-platform digital 
                                        world has existed for years. We’ve seen it take form in everything from video games to social media. 
                                        From World of Warcraft and Runescape to MySpace, the early versions of the metaverse have been a part of our world for 
                                        quite a while. The 2020s metaverse simply builds on these ideas and takes them to the next level.</p>
                            </div>

                            {/* <!-- Comment Section Area Start --> */}
                            <div className="comment-inner">
                                <h3 className="title mb--40 mt--50">Leave a Reply</h3>
                                <form action="#">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group"><input type="text" placeholder="Name" />
                                            </div>
                                            <div className="rnform-group"><input type="email" placeholder="Email" />
                                            </div>
                                            <div className="rnform-group"><input type="text" placeholder="Website" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-12 col-12">
                                            <div className="rnform-group">
                                                <textarea placeholder="Comment"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <a className="rn-btn" href="#"><span>SUBMIT NOW</span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            {/* <!-- Comment Section End --> */}
                        </div>
                        {/* <!-- End of .modal-body --> */}
                    </div>
                </div>
            </div>
            {/* <!-- End Modal Blog area --> */}
        </>
    )
}

export default Blog